export const inputCls = "w-full rounded-lg bg-black/50 border border-white/10 px-3 py-2.5 text-sm text-white outline-none focus:border-[#D4AF37] focus:ring-1 focus:ring-[#D4AF37]";

export function PageTitle({ title, subtitle, right }) {
  return (
    <div className="flex items-start justify-between gap-4 mb-6 flex-wrap">
      <div>
        <h1 className="font-display text-2xl sm:text-3xl">{title}</h1>
        {subtitle && <p className="mt-1 text-sm text-white/50">{subtitle}</p>}
      </div>
      {right}
    </div>
  );
}

export function GBtn({ children, variant = "solid", className = "", ...props }) {
  const base = "inline-flex items-center justify-center gap-2 rounded-lg px-4 py-2 text-sm font-medium transition-colors disabled:opacity-50";
  const styles = variant === "solid" ? "bg-gradient-to-r from-[#D4AF37] to-[#F0D77B] text-[#0A0A0A] hover:opacity-90"
    : variant === "ghost" ? "border border-white/15 text-white/80 hover:bg-white/5"
    : "border border-red-500/40 text-red-400 hover:bg-red-500/10";
  return <button className={`${base} ${styles} ${className}`} {...props}>{children}</button>;
}

export function Field({ label, children }) {
  return (
    <div>
      <label className="block text-xs uppercase tracking-wider text-white/50 mb-1.5">{label}</label>
      {children}
    </div>
  );
}

export function Card({ children, className = "" }) {
  return <div className={`card-surface rounded-2xl p-5 ${className}`}>{children}</div>;
}

export const STATUSES = ["Awaiting Questionnaire", "Questionnaire Received", "In Progress", "Delivered"];

export function StatusBadge({ status }) {
  const map = {
    "Pending Payment": "bg-white/10 text-white/50",
    "Awaiting Questionnaire": "bg-amber-500/15 text-amber-300",
    "Questionnaire Received": "bg-blue-500/15 text-blue-300",
    "In Progress": "bg-purple-500/15 text-purple-300",
    "Delivered": "bg-emerald-500/15 text-emerald-300",
    "New": "bg-amber-500/15 text-amber-300",
    "Approved": "bg-blue-500/15 text-blue-300",
    "Link Sent": "bg-emerald-500/15 text-emerald-300",
    "Declined": "bg-red-500/15 text-red-300",
    "delivered": "bg-emerald-500/15 text-emerald-300",
    "failed": "bg-red-500/15 text-red-300",
  };
  return <span className={`inline-block rounded-full px-2.5 py-0.5 text-xs whitespace-nowrap ${map[status] || "bg-white/10 text-white/60"}`}>{status}</span>;
}
